<template>
  <div>
    <!-- 頭部 -->
    <Header></Header>
    <div class="lbt">
      <el-carousel indicator-position="outside" height="650px">
        <el-carousel-item v-for="item in ban1.length" :key="item" >
            <el-image class="ban1_dt" :src="ban1[item-1].url"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 新產品 -->
    <div class="cxcpdk">
      <div class="cxcp-title">新品推薦</div>
      <div class="cxcp-subtitle">堅持創新，完善產品</div>
      <div><el-image :src="jt"></el-image></div>
      <div class="cxcpmk clearfix">
        <div
          class="cxcp"
          @click="openBox(item.prod_sn)"
          v-for="item of cxcp"
          :key="item.index"
        >
          <el-image class="cxcp-tp" :src="item.url"></el-image>
          <div class="cxcp-wz">{{ item.prod_des }}</div>
        </div>
      </div>
    </div>
    <!-- 系列跳轉 -->
    <div class="xl-shang">
      <div>
        <el-image class="xl-tp" :src="xl[0]"></el-image>
        <div class="xl-shang-left-wz">
          <div class="xl-shang-title">梳化系列</div>
          <div class="xl-subtitle">
            <div class="xl-shang-subtitle">
              在制作和设计的理念上都以休闲舒适为主，
            </div>
            <div class="xl-shang-subtitle">
              满足了用户生活和运动的各种需要。我们致力于创
            </div>
            <div class="xl-shang-subtitle">
              造更为阳光休闲的生活，带给用户更快乐轻松的状态
            </div>
          </div>
          <div class="mbtn">
            <el-button size="medium" @click="toSf">查看更多</el-button>
          </div>
        </div>
      </div>
      <div>
        <el-image class="xl-tp" :src="xl[1]"></el-image>
        <div class="xl-shang-right-wz">
          <div class="xl-shang-title2">床褥系列</div>
          <div class="xl-subtitle">
            <div class="xl-subtitle">
              <div class="xl-shang-subtitle2">足够大的睡眠空间</div>
              <div class="xl-shang-subtitle2">
                舒适的躺着，让睡眠成为一种享受
              </div>
            </div>
          </div>
          <div class="mbtn">
            <el-button size="medium" @click="toCd">查看更多</el-button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-image class="xl-tp" :src="xl[2]"></el-image>
      <div class="xl-xia-wz">
        <div class="xl-xia-title">床品系列</div>
        <div class="xl-xia-subtitle">
          每一道程序均严格把控，产品品质更优于市场上的同类产品
        </div>
        <div class="xl-xia-subtitle">在提高性价比的同时坚决不降低产品品质</div>
        <div class="mbtn">
          <el-button size="medium" @click="toCp">查看更多</el-button>
        </div>
      </div>
    </div>
    <!-- 品牌介紹 -->
    <div>
      <div class="ppjs-title">品牌介紹</div>
      <div class="ppjs-subtitle">不忘初心，堅持創新</div>
      <div class="ppjs">
        <div><el-image class="ppjs-left" :src="ppjs"></el-image></div>
        <div class="ppjs-right">
          <div class="ppjs-right-title">IDEA</div>
          <div class="ppjs-right-subtitle">PHASE ——</div>
          <div class="ppjs-right-wz">
            <span class="ppjs-right-gs" @click="toAbout"
              >樂滿門床具有限公司</span
            >
            <span>
              經過30多年的發展，公司始終恪守
              "創新,品質，服務，經濟，奉獻感恩"的十二字理念。吸收新思想，嚴格控制品質，跟蹤全方位服務，堅持生產優質產品。</span
            >
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Box
      :dialogVisible="box.dialogVisible"
      :goods_id="box.goods_id"
      @close="boxClose"
    ></Box>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Box from "@/components/Box";
export default {
  name: "home",
  data() {
    return {
      ban1: [{id: "00001", url: ""}],
      xl: [
        "http://139.159.153.112:8200/gw_lmm/home1.jpg",
        "http://139.159.153.112:8200/gw_lmm/home2.jpg",
        "http://139.159.153.112:8200/gw_lmm/home3.jpg",
      ],
      jt: "http://139.159.153.112:8200/gw_lmm/home4.png",
      cxcp:[],
      //   品牌介紹
      ppjs: "http://139.159.153.112:8200/gw_lmm/home5.png",
      box: {
        dialogVisible: false,
        goods_id: "",
      },
      place:"R",
    };
  },
  created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.place=sessionStorage.getItem("company_sn")
        this.queryBanner()
        this.queryProd()
    }
  },
  methods: {
    // 查询广告
    queryBanner() {
      this.$api.banner({place:this.place}).then(
        res => {
          console.log(res)
          if (res.state == 10000) {
            this.ban1=res.data.banner
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
    // 查询推荐货品
    queryProd() {
      console.log(this.place)
      this.$api.queryprod({company_sn:this.place,category_sn:"",high:1}).then(
        res => {
          if (res.state == 10000) {
            this.cxcp=res.data.prod
            console.log(this.cxcp)
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
    openBox(goods_id) {
      this.box.dialogVisible = true;
      this.box.goods_id = goods_id;
    },
    // 弹窗的搜索关闭
    boxClose(val) {
      this.box.dialogVisible = val;
    },
    // 跳转到梳化
    toSf() {
      this.$router.push({ path: "/goods/sf" });
    },
    // 跳转到床墊
    toCd() {
      this.$router.push({ path: "/goods/cd" });
    },
    // 跳转到床品
    toCp() {
      this.$router.push({ path: "/goods/cp" });
    },
    // 跳转到床品
    toAbout() {
      this.$router.push({ path: "/about" });
    },
  },
  components: { Header, Footer, Box },
};
</script>

<style scoped>
/* 輪播圖模塊 */
.lbt {
  width: 100%;
  height: 650px;
}
.ban1_dt {
  width: 100%;
  height: 650px;
}
.ban1_pt1 {
  width: 350px;
  height: 350px;
  position: relative;
  top: -400px;
}
.ban1_wz1 {
  font-size: 45px;
  position: relative;
  top: -660px;
  color: #fff;
  font-family: fontface__幼圆__7__607228568617;
}
.ban1_wz2 {
  position: relative;
  top: -645px;
  font-size: 22px;
}
.ban1_wz3 {
  position: relative;
  top: -630px;
  font-size: 18px;
  color: #fff;
}

/* 創新產品 */
.cxcpdk {
  padding-top: 100px;
  background: rgb(244, 244, 244);
}
.cxcp-title {
  font-size: 30px;
  color: #2b2b2b;
}
.cxcp-subtitle {
  line-height: 50px;
  color: #444444;
}
.cxcpmk {
  width: 1080px;
  margin: 0 auto;
}
.cxcp {
  float: left;
  width: 320px;
  height: 380px;
  margin: 20px;
  background-color: #ffffff;
  /* box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1); */
}
.cxcp-tp {
  margin-top: 30px;
  width: 320px;
  height: 250px;
}

/* 系列 */
.xl-shang {
  display: flex;
  justify-content: flex-start;
  height: 500px;
}
.xl-tp {
  height: 500px;
}
.xl-shang-left-wz {
  position: relative;
  top: -400px;
  text-align: right;
  margin-right: 150px;
}
.xl-shang-right-wz {
  position: relative;
  top: -400px;
  text-align: left;
  margin-left: 150px;
}
.xl-shang-title {
  font-size: 36px;
  color: #ffffff;
  margin-bottom: 40px;
}
.xl-shang-subtitle {
  line-height: 1.8;
  font-size: 14px;
  color: #ffffff;
}
.xl-shang-title2 {
  font-size: 36px;
  color: #3e3e3e;
  margin-bottom: 40px;
}
.xl-shang-subtitle2 {
  line-height: 1.8;
  font-size: 14px;
  color: #3e3e3e;
}
.xl-xia-wz {
  position: relative;
  top: -400px;
  text-align: left;
  margin-left: 500px;
}
.xl-xia-title {
  font-size: 36px;
  color: #ffffff;
  margin-bottom: 40px;
}
.xl-xia-subtitle {
  line-height: 1.8;
  font-size: 14px;
  color: #ffffff;
}
.xl-subtitle {
  height: 80px;
}
.mbtn {
  margin-top: 40px;
}

/* 品牌介紹 */
.ppjs-title {
  font-size: 30px;
  color: #2b2b2b;
}
.ppjs-subtitle {
  line-height: 50px;
  color: #444444;
  margin-bottom: 20px;
}
.ppjs {
  display: flex;
  justify-content: flex-start;
}
.ppjs-left {
  height: 560px;
}
.ppjs-right {
  width: 450px;
  text-align: left;
  margin: 100px 0 0 100px;
}
.ppjs-right-title {
  color: rgb(179, 141, 84);
  font-size: 54px;
  font-family: impact;
}
.ppjs-right-subtitle {
  color: #333;
  font-size: 54px;
  font-family: impact;
}
.ppjs-right-wz {
  margin-top: 50px;
  font-size: 14px;
  line-height: 24px;
  color: #999999;
}
.ppjs-right-gs {
  color: rgb(179, 141, 84);
}
</style>
